import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const NotificationSection = ({ notificationSettings, onUpdate }) => {
  const [settings, setSettings] = useState({
    email: {
      newFollowers: notificationSettings?.email?.newFollowers !== false,
      broadcastStarts: notificationSettings?.email?.broadcastStarts !== false,
      comments: notificationSettings?.email?.comments !== false,
      donations: notificationSettings?.email?.donations !== false,
      weeklyDigest: notificationSettings?.email?.weeklyDigest !== false
    },
    push: {
      newFollowers: notificationSettings?.push?.newFollowers !== false,
      broadcastStarts: notificationSettings?.push?.broadcastStarts !== false,
      comments: notificationSettings?.push?.comments !== false,
      donations: notificationSettings?.push?.donations !== false,
      liveReminders: notificationSettings?.push?.liveReminders !== false
    }
  });

  const handleCheckboxChange = (category, name, checked) => {
    setSettings(prev => ({
      ...prev,
      [category]: {
        ...prev?.[category],
        [name]: checked
      }
    }));
  };

  const handleSave = () => {
    onUpdate(settings);
  };

  const toggleAllEmail = (enabled) => {
    setSettings(prev => ({
      ...prev,
      email: {
        newFollowers: enabled,
        broadcastStarts: enabled,
        comments: enabled,
        donations: enabled,
        weeklyDigest: enabled
      }
    }));
  };

  const toggleAllPush = (enabled) => {
    setSettings(prev => ({
      ...prev,
      push: {
        newFollowers: enabled,
        broadcastStarts: enabled,
        comments: enabled,
        donations: enabled,
        liveReminders: enabled
      }
    }));
  };

  return (
    <div className="notification-section bg-card rounded-lg p-6 shadow-soft">
      <div className="section-header flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Bell" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            Уведомления
          </h2>
          <p className="text-sm text-muted-foreground">
            Настройка оповещений по email и в приложении
          </p>
        </div>
      </div>
      <div className="notification-content space-y-6">
        <div className="email-notifications">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Icon name="Mail" size={18} color="var(--color-foreground)" />
              <h3 className="text-base font-medium text-foreground">
                Email уведомления
              </h3>
            </div>
            <div className="flex gap-2">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => toggleAllEmail(true)}
              >
                Включить все
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => toggleAllEmail(false)}
              >
                Выключить все
              </Button>
            </div>
          </div>
          <div className="space-y-3">
            <Checkbox
              label="Новые подписчики"
              description="Уведомление когда кто-то подписывается на ваш канал"
              checked={settings?.email?.newFollowers}
              onChange={(e) => handleCheckboxChange('email', 'newFollowers', e?.target?.checked)}
            />
            <Checkbox
              label="Начало трансляций"
              description="Когда каналы, на которые вы подписаны, начинают эфир"
              checked={settings?.email?.broadcastStarts}
              onChange={(e) => handleCheckboxChange('email', 'broadcastStarts', e?.target?.checked)}
            />
            <Checkbox
              label="Комментарии"
              description="Новые комментарии к вашим эфирам"
              checked={settings?.email?.comments}
              onChange={(e) => handleCheckboxChange('email', 'comments', e?.target?.checked)}
            />
            <Checkbox
              label="Донаты"
              description="Уведомления о полученных пожертвованиях"
              checked={settings?.email?.donations}
              onChange={(e) => handleCheckboxChange('email', 'donations', e?.target?.checked)}
            />
            <Checkbox
              label="Еженедельная сводка"
              description="Статистика и активность за неделю"
              checked={settings?.email?.weeklyDigest}
              onChange={(e) => handleCheckboxChange('email', 'weeklyDigest', e?.target?.checked)}
            />
          </div>
        </div>

        <div className="push-notifications pt-6 border-t border-border">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Icon name="Smartphone" size={18} color="var(--color-foreground)" />
              <h3 className="text-base font-medium text-foreground">
                Push-уведомления
              </h3>
            </div>
            <div className="flex gap-2">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => toggleAllPush(true)}
              >
                Включить все
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => toggleAllPush(false)}
              >
                Выключить все
              </Button>
            </div>
          </div>
          <div className="space-y-3">
            <Checkbox
              label="Новые подписчики"
              description="Мгновенное уведомление о новых подписчиках"
              checked={settings?.push?.newFollowers}
              onChange={(e) => handleCheckboxChange('push', 'newFollowers', e?.target?.checked)}
            />
            <Checkbox
              label="Начало трансляций"
              description="Когда избранные каналы выходят в эфир"
              checked={settings?.push?.broadcastStarts}
              onChange={(e) => handleCheckboxChange('push', 'broadcastStarts', e?.target?.checked)}
            />
            <Checkbox
              label="Комментарии"
              description="Новые комментарии к вашему контенту"
              checked={settings?.push?.comments}
              onChange={(e) => handleCheckboxChange('push', 'comments', e?.target?.checked)}
            />
            <Checkbox
              label="Донаты"
              description="Мгновенное уведомление о пожертвованиях"
              checked={settings?.push?.donations}
              onChange={(e) => handleCheckboxChange('push', 'donations', e?.target?.checked)}
            />
            <Checkbox
              label="Напоминания о прямых эфирах"
              description="За 10 минут до начала запланированных трансляций"
              checked={settings?.push?.liveReminders}
              onChange={(e) => handleCheckboxChange('push', 'liveReminders', e?.target?.checked)}
            />
          </div>
        </div>

        <div className="notification-info p-4 bg-accent/10 rounded-lg border border-accent/20">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} color="var(--color-accent)" />
            <div>
              <h4 className="text-sm font-medium text-foreground mb-1">
                Управление уведомлениями
              </h4>
              <p className="text-xs text-muted-foreground">
                Push-уведомления требуют разрешения браузера. Вы можете настроить частоту получения email-уведомлений в настройках почты.
              </p>
            </div>
          </div>
        </div>

        <div className="form-actions flex items-center gap-3 pt-6 border-t border-border">
          <Button
            variant="default"
            onClick={handleSave}
            iconName="Check"
            iconPosition="left"
          >
            Сохранить настройки
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotificationSection;